import "bkoi-gl/dist/style/bkoi-gl.css";
// import "mapbox-gl/dist/mapbox-gl.css";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import store from "./app/store";
import Loader from "./components/ui/Loader";
import {
  KEYCLOAK_CLIENT_ID,
  KEYCLOAK_REALM,
  KEYCLOAK_URL,
} from "./config/global.config";
import reportWebVitals from "./reportWebVitals";
import "./styles/antd.css";
import "./styles/index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

export const keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
});

root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: "check-sso",
      silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
      pkceMethod: "S256",
      checkLoginIframe: false,
    }}
    onEvent={(event, error) => {
      console.log(error);
    }}
    LoadingComponent={<Loader />}
  >
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ReactKeycloakProvider>,
);

reportWebVitals();
